import { createStore } from 'vuex'

import auth from '@/store/modules/auth'
import other from '@/store/modules/other'
import news from '@/store/modules/news'
import storyChange from '@/store/modules/storyChange'
import roles from '@/store/modules/roles'
import products from '@/store/modules/products'
import constructor from '@/store/modules/constructor'
import achievements from '@/store/modules/achievements'
import mainBanners from '@/store/modules/mainBanners'
import productsMoving from '@/store/modules/productsMoving'
import tags from '@/store/modules/tags'
import keywords from '@/store/modules/keywords'
import groupLearning from '@/store/modules/groupLearning'
import teachers from '@/store/modules/teachers'
import materialsEducation from '@/store/modules/materialsEducation'
import newsEducation from '@/store/modules/newsEducation'
import informationEducation from '@/store/modules/informationEducation'
import structureEducation from '@/store/modules/structureEducation'
import regions from '@/store/modules/regions'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    other,
    news,
    storyChange,
    roles,
    products,
    constructor,
    achievements,
    mainBanners,
    productsMoving,
    tags,
    keywords,
    regions,
    groupLearning,
    teachers,
    materialsEducation,
    newsEducation,
    informationEducation,
    structureEducation
  }
})
